import { withChildren } from '@builder.io/react';
import React from 'react';

import { Tooltip as TooltipComponent, TooltipProps } from '@videoblocks/design-system';

interface TooltipBuilderProps extends TooltipProps {
    side?: 'left' | 'right' | 'top' | 'bottom';
}

function Tooltip({ children, title, description, variant, hasArrow, side, defaultOpen }: TooltipBuilderProps) {
    return (
        <TooltipComponent
            title={title}
            descriptionHtml={description}
            trigger={
                <div className="inline-block" tabIndex={0}>
                    {children}
                </div>
            }
            variant={variant}
            hasArrow={hasArrow}
            defaultOpen={defaultOpen}
            contentProps={{ side }}
        />
    );
}

export default withChildren(Tooltip);
